import * as React from 'react';
import { Box } from '@mui/material';
import IdleTimer from '../IdleTimer';
import Drawer from '../../ui/drawer/Drawer';
import { ActiveOrderProvider } from '../../../contexts/ActiveOrderContext';

type PropsWithChildren<P> = P & { children?: React.ReactNode };

type IProps = PropsWithChildren<{}>;

const Layout = (props: IProps) => {
  return (
    <ActiveOrderProvider>
      <Box
        display="flex"
        flexDirection="row"
        sx={{
          mt: { xs: '56px', lg: 0 },
          maxWidth: '100%',
          width: '100%',
          overflowX: 'hidden', // prevent horizontal scroll
        }}
      >
        <Drawer />

        <Box sx={{ flex: 1, overflow: 'hidden' }}>
          {props.children}
        </Box>

        <IdleTimer />
      </Box>
    </ActiveOrderProvider>
  );
};

export default Layout;
